import { useEffect, useState } from 'react';

interface Props {
  onFinish?: () => void;
  isReady?: boolean;
}

export default function SplashLoader({ onFinish, isReady = false }: Props) {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    let timeout1: NodeJS.Timeout;
    let timeout2: NodeJS.Timeout;

    if (isReady) {
      timeout1 = setTimeout(() => {
        setIsExiting(true);
        timeout2 = setTimeout(() => {
          onFinish?.();
        }, 500);
      }, 100);
    }

    return () => {
      if (timeout1) clearTimeout(timeout1);
      if (timeout2) clearTimeout(timeout2);
    };
  }, [isReady, onFinish]);

  return (
    <div
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#050B18] transition-all duration-700 ease-in-out ${
        isExiting ? 'opacity-0 scale-110 pointer-events-none' : 'opacity-100'
      }`}
    >
      {/* Background Glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(34,81,146,0.15),transparent_70%)]" />

      <div className="relative z-10 flex flex-col items-center">
        {/* Logo Container */}
        <div className="relative mb-12 animate-pulse transition-transform duration-500 hover:scale-105">
          <img
            src="/images/logoWithText.svg"
            className="h-20 md:h-28 drop-shadow-[0_0_25px_rgba(255,255,255,0.2)]"
            alt="Decent Den Logo"
          />
        </div>

        {/* Loading Bar Container */}
        <div className="w-[300px] md:w-[450px] space-y-4">
          <div className="flex justify-center items-center text-white/60 font-Genos text-sm tracking-[4px] uppercase">
            <span>Loading Experience</span>
          </div>

          <div className="w-full h-[6px] bg-white/5 rounded-full overflow-hidden backdrop-blur-sm border border-white/10 relative">
            {/* Infinite Scanning Fill */}
            <div className="absolute top-0 bottom-0 w-1/3 bg-gradient-to-r from-transparent via-[#2C3FC2] to-transparent rounded-full shadow-[0_0_15px_rgba(44,63,194,0.8)] animate-[scan_1.5s_ease-in-out_infinite]" />
          </div>
        </div>

        {/* Tagline */}
        <p className="mt-8 font-khmer text-white/40 text-sm tracking-wider animate-pulse">
          Wait for the Den..
        </p>
      </div>

      <style>{`
        @keyframes scan {
          0% { left: -35%; }
          50% { left: 100%; }
          100% { left: -35%; }
        }
      `}</style>
    </div>
  );
}
